import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { color } from '@/themes/color';
import { typography } from '@/themes/typography';
import modalBanner from '@/assets/modalBanner.webp';

function CloseIcon(): JSX.Element {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

export default function SuccessModal({
  open,
  onClose,
  title = 'Subscribed!',
  message = 'Thank you for subscribing to our newsletter. Check your email for updates on the latest vineyards and events.',
}: SuccessModalProps): JSX.Element {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="success-modal-title"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: '16px', sm: '24px' },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          backgroundColor: '#F9F8F6',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '400px',
          pt: { xs: '40px', sm: '80px' },
          px: { xs: '28px', sm: '100px' },
          pb: 0,
          outline: 'none',
          overflow: 'hidden',
        }}
      >
        {/* Close button */}
        <IconButton
          onClick={onClose}
          aria-label="Close"
          size="small"
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            color: color.charcoal['400'],
            '&:hover': { color: color.charcoal.default },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Checkmark icon */}

        {/* Heading */}
        <Typography
          id="success-modal-title"
          sx={{
            ...typography.display,
            color: color.charcoal.default,
            mb: '20px',
            lineHeight: 1.1,
            fontSize: {
              xs: 'var(--font-size-36, 36px)',
              sm: typography.display.fontSize,
            },
          }}
        >
          {title}
        </Typography>

        {/* Message */}
        <Typography
          sx={{
            ...typography.bodyText,
            color: color.charcoal['500'],
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>

        {/* Bottom banner */}
        <Box
          component="img"
          src={modalBanner}
          alt=""
          aria-hidden
          loading="lazy"
          sx={{
            display: 'block',
            width: { xs: 'calc(100% + 56px)', sm: 'calc(100% + 200px)' },
            mx: { xs: '-28px', sm: '-100px' },
            mt: '32px',
            pointerEvents: 'none',
          }}
        />
      </Box>
    </Modal>
  );
}
